import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  outbound_items_form_details: [],
};

const getters = {
  allOutboundItemsFormDetails: (state) => state.outbound_items_form_details,
};

const actions = {
  async fetchOutboundItemsFormDetails({ commit }, params = {}) {
    try {
      commit("resetOutboundItemsFormDetails");
      const response = await axios.get("/outbound-items-form-detail", { params: prm(params) });
      commit("setOutboundItemsFormDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outbound_items_form_details:", error);
    }
  },
  async createOutboundItemsFormDetail({ commit }, outbound_items_form_detail) {
    try {
      const response = await axios.post("/outbound-items-form-detail", outbound_items_form_detail);
      commit("addOutboundItemsFormDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create outbound_items_form_detail:", error);
      throw error;
    }
  },
  async fetchOutboundItemsFormDetailById(_, id) {
    try {
      const response = await axios.get(`/outbound-items-form-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outbound_items_form_detail:", error);
      throw error;
    }
  },
  async updateOutboundItemsFormDetail({ commit }, outbound_items_form_detail) {
    try {
      const response = await axios.put(`/outbound-items-form-detail/${outbound_items_form_detail.id}`, outbound_items_form_detail);
      commit("updateOutboundItemsFormDetail", response.data);
    } catch (error) {
      console.error("Failed to update outbound_items_form_detail:", error);
      throw error;
    }
  },
  async deleteOutboundItemsFormDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/outbound-items-form-detail/${id}`);
      commit("removeOutboundItemsFormDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete outbound_items_form_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setOutboundItemsFormDetails(state, outbound_items_form_details) {
    state.outbound_items_form_details = outbound_items_form_details.data; // Ensure this matches your API's response structure
  },
  addOutboundItemsFormDetail(state, outbound_items_form_detail) {
    state.outbound_items_form_details.push(outbound_items_form_detail);
  },
  updateOutboundItemsFormDetail(state, updatedOutboundItemsFormDetail) {
    const index = state.outbound_items_form_details.findIndex(
      (outbound_items_form_detail) => outbound_items_form_detail.id === updatedOutboundItemsFormDetail.id
    );
    if (index !== -1) {
      state.outbound_items_form_details.splice(index, 1, updatedOutboundItemsFormDetail);
    }
  },
  removeOutboundItemsFormDetail(state, id) {
    state.outbound_items_form_details = state.outbound_items_form_details.filter(
      (outbound_items_form_detail) => outbound_items_form_detail.id !== id
    );
  },
  resetOutboundItemsFormDetails(state) {
    state.outbound_items_form_details = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
